import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/AudiusLogoHorizontalNew.svg'

export const IconAudiusLogoHorizontalNew = IconSVG as IconComponent
